/**
 * @license
 * Copyright Paysafe 2026. All rights reserved.
 */

export enum CheckoutSuccessType {
  PAYMENT_COMPLETED = 'PAYMENT_COMPLETED'
}
